module.exports = __webpack_public_path__ + "img/arrows-up-down.14ddd8da.svg";